import { http } from '../../plugins/http';
import { getData } from '../../utils/get';

export default {

    show(key, hash) {
        return http.get(`/api/registration/show/${key}/${hash}`).then(getData);
    },

    register(invitationKey, params) {
        return http.post(`/api/registration/register/${invitationKey}`, params).then(getData);
    },

    showTenant(key, hash) {
        return http.get(`/api/registration/show-tenant/${key}/${hash}`).then(getData);
    },

    registerTenant(invitationKey, params) {
        return http.post(`/api/registration/register-tenant/${invitationKey}`, params).then(getData);
    }
};



// WEBPACK FOOTER //
// ./src/services/Auth/RegisterController.js